var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"6"}},[_c('BackButton',{attrs:{"path":"/"}})],1),_c('v-col',{staticClass:"text-align",attrs:{"cols":"6"}},[_c('CreateRoomDialog')],1)],1),_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('ListOfRooms')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }